import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { Observable } from 'rxjs';

import { LoginService } from '../services/login.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private webStorageService: WebStorageService,
    private loginService: LoginService,
    private cookieService:CookieService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.webStorageService.getItemFromSessionStorage('token');
    const company = this.webStorageService.getItemFromSessionStorage('company');

    const ASPNET_SessionId= this.webStorageService.getItemFromSessionStorage("ASPNET_SessionId");
    //alert(this.cookieService.get("ASP.NET_SessionId"));
    const session_ID = this.webStorageService.getItemFromSessionStorage("SessionID");
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${company}*${token}*${session_ID}*${ASPNET_SessionId}`,
          Token: token
        },
      });
    }
    return next.handle(request).pipe();
  }
}
